import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
} from '@mui/material';
import Barcode from 'react-barcode';
import { useBarcodePrint } from '../hooks';
import styles from './BarcodePrintModal.module.css';

interface BarcodePrintModalProps {
  open: boolean;
  onClose: () => void;
  asset: {
    id: string;
    barcode?: string;
    assetType?: { name: string };
    brand?: { name: string };
    model?: { name: string };
    serialNumber: string;
    brandDetails?: { name: string };
    modelDetails?: { name: string };
    typeDetails?: { name: string };
    typeInfo?: { name: string };
  };
}

const BarcodePrintModal: React.FC<BarcodePrintModalProps> = ({
  open,
  onClose,
  asset,
}) => {
  const barcodeValue = asset.barcode || `ASSET-${asset.id}`;
  const assetWithBarcode = { ...asset, barcode: barcodeValue };
 
  const { printRef, handlePrint, hasBarcode } = useBarcodePrint({
    asset: assetWithBarcode,
  });

  const brandName = asset.brand?.name || asset.brandDetails?.name || 'Marca';
  const modelName = asset.model?.name || asset.modelDetails?.name || 'Modelo';
  const assetTypeName =
    asset.assetType?.name ||
    asset.typeDetails?.name ||
    asset.typeInfo?.name ||
    'Tipo';

  const handlePrintAndClose = () => {
    try {
      handlePrint();
    } catch (error) {
      console.error('Error al imprimir:', error);
    }
    
    setTimeout(() => {
      onClose();
    }, 2000);
  };

  if (!hasBarcode) {
    return (
      <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
        <DialogTitle>Error</DialogTitle>
        <DialogContent>
          <Typography>
            Este activo no tiene un código de barras asignado.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cerrar</Button>
        </DialogActions>
      </Dialog>
    );
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle>Imprimir Código de Barras</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <div ref={printRef} className={styles.barcodeContainer}>
            <div className={styles.barcodeSection}>
              <div className={styles.logoSection}>
                <div className={styles.companyName}>SOY DELIVERY</div>
              </div>
              <div className={styles.assetInfo}>
                <div className={styles.assetType}>{assetTypeName}</div>
                <div className={styles.assetModel}>
                  {brandName} - {modelName}
                </div>
                <div className={styles.serialNumber}>
                  S/N: {asset.serialNumber}
                </div>
              </div>
              <Barcode
                value={barcodeValue}
                format='CODE128'
                width={1.8}
                height={40}
                displayValue={false}
                fontSize={0}
              />
              <div className={styles.barcodeValue}>{barcodeValue}</div>
            </div>
          </div>
        </Box>
        <Typography variant='body2' color='text.secondary' align='center'>
          Se abrirá una nueva ventana para imprimir el código de barras
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button onClick={handlePrintAndClose} variant='contained' color='primary'>
          Imprimir
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BarcodePrintModal;
